import { Component, input, model } from '@angular/core';

@Component({
  selector: 'mbp-radio-group',
  templateUrl: './mbp-radio-group.component.html',
  styleUrl: './mbp-radio-group.component.scss'
})
export class MbpRadioGroupComponent {
  value = model<unknown>(undefined);
  disabled = input<boolean>(false);

  select(value: unknown): void {
    this.value.set(value);
  }
}
